const pushEvent = (event, args) => {
    if (!window.hasOwnProperty('dataLayer')) {
        console.warn('No data layer was detected!');
    }

    window.dataLayer?.push({
        event,
        ...args
    });
};

export default pushEvent;
